module.exports = __webpack_public_path__ + "assets/img/pyramid.f57507b4.png";